import React, { useContext } from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CommonUtil from "../../Util/CommonUtils";
import { TextField, Popper, Paper, Typography } from "@mui/material";
import { ThemeContext } from "../../theme/ThemeContext";
import { styled } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const CustomPopper = styled(Popper)(({ darkMode }) => ({
  "& .MuiAutocomplete-listbox": {
    backgroundColor: darkMode ? " #1c354b" : "#fff", // Dropdown background color
    color: darkMode ? "#fff" : "#000", // Dropdown text color
  },
  "& .MuiAutocomplete-option": {
    backgroundColor: darkMode ? " #1c354b" : "#fff", // Option background color
    "&[aria-selected='true']": {
      backgroundColor: darkMode ? "#0D1926" : "#e6f7ff", // Background color when an option is selected
    },
    "&:hover": {
      backgroundColor: darkMode ? "#949596" : "#e6f7ff", // Hover background color
    },
  },
}));

const CustomPaper = styled(Paper)(({ darkMode }) => ({
  backgroundColor: darkMode ? " #1c354b" : "#fff", // Background color for the dropdown container
  color: darkMode ? "#fff" : "#000", // Text color for options
}));

const CssTextField = styled((props) => <TextField {...props} />)(
  ({ darkMode }) => ({
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: darkMode ? "#576A7A" : "#ccc", // Default border color for the fieldset
      },
      "&:hover fieldset": {
        borderColor: darkMode ? "#fafafa" : "rgba(0, 0, 0, 0.4)", // Border color when hovered
      },
      "&.Mui-focused fieldset": {
        borderColor: darkMode ? "#fff" : "#0F273B", // Border color when focused
      },
    },
    "& .MuiInputLabel-root": {
      color: darkMode ? "rgba(255, 255, 255, 0.6)" : "#707070", // Label color
    },
    "& .MuiFormLabel-root": {
      fontSize: "0.875rem",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      color: darkMode ? "#fff" : "#000",
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "#949596",
    },
    "& .MuiSvgIcon-root": {
      color: "#949596",
    },
  })
);

const NoOptionsText = styled(Typography)(({ darkMode }) => ({
  color: darkMode ? "#fff" : "#000",
  padding: "10px",
}));

export default function AutocompleteComponent({
  options,
  onSelect,
  error,
  InputProps,
  label,
  defaultValue,
  onBlur,
  value,
  multiple,
  disabled,
  renderOption,
  disableCloseOnSelect,
  ...props
}) {
  const filterOptions = createFilterOptions({
    stringify: ({ name, code }) => `${name} ${code}`,
  });
  const { darkMode } = useContext(ThemeContext);

  return (
    <>
      <Autocomplete
        popupIcon={<ExpandMoreIcon />}
        multiple={multiple}
        disableCloseOnSelect={disableCloseOnSelect}
        disabled={disabled}
        noOptionsText={
          <NoOptionsText darkMode={darkMode}>No Options found</NoOptionsText>
        }
        size="small"
        filterOptions={filterOptions}
        getOptionLabel={(option) => (option.name ? option.name : "")}
        options={CommonUtil.isEmpty(options) ? [] : options}
        renderOption={renderOption}
        onChange={(event, newValue) => {
          if (!CommonUtil.isEmpty(newValue)) {
            onSelect(newValue);
          }
        }}
        onBlur={onBlur}
        autoHighlight={true}
        PopperComponent={(props) => (
          <CustomPopper {...props} darkMode={darkMode} />
        )}
        PaperComponent={(props) => (
          <CustomPaper {...props} darkMode={darkMode} />
        )}
        renderInput={(params) => (
          <CssTextField
            sx={[
              () => ({
                "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall ": {
                  paddingTop: "14px !important",
                  paddingBottom: "14px !important",
                },
              }),
            ]}
            {...params}
            className="invite_company"
            required={props.required}
            variant="outlined"
            fullWidth
            helperText={error}
            label={label}
            value={value}
            error={error}
            darkMode={darkMode}
          />
        )}
      />
    </>
  );
}
